import { compressToEncodedURIComponent, decompressFromEncodedURIComponent } from 'lz-string';

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var addParameterToUrl = function addParameterToUrl(key, value) {
  var encoded = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (!window.top) {
    return;
  }
  var url = new URL(window.top.location.href);
  var param = encoded ? compressToEncodedURIComponent(value) : value;
  url.searchParams.set(key, param);
  window.top.history.replaceState('data', 'title', url.href);
};
var getParameterFromUrl = function getParameterFromUrl(key) {
  var parseAsJSON = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var encoded = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var falsyValue = arguments.length > 3 ? arguments[3] : undefined;
  if (!window.top) {
    return null;
  }
  var value;
  try {
    var url = new URL(window.top.location.href);
    value = url.searchParams.get(key) || '';
  } catch (e) {
    console.warn("Error getting URL parameter: '".concat(e.message, "'. No data retrieved"));
    return null;
  }
  // TODO improve or delete
  // try {
  // 	if (!value || value === falsyValue) {
  // 		return null
  // 	}
  // 	return parseAsJSON ? JSON.parse(value) : value
  // } catch (e) {
  // 	console.log(`couldn't parse URL parameter as is: ${e.message}, it's decompression time`)
  // }
  var param = encoded ? decompressFromEncodedURIComponent(value) : value;
  try {
    if (!param || param === falsyValue) {
      return null;
    }
    return parseAsJSON ? JSON.parse(param) : param;
  } catch (e) {
    console.warn("Error parsing URL parameter: '".concat(e.message, "'. No data retrieved"));
    return null;
  }
};
var removeParamsFromUrl = function removeParamsFromUrl(keys) {
  if (!window.top) {
    return;
  }
  var url = new URL(window.top.location.href);
  var params = new URLSearchParams(url.search);
  var urlNoParams = url.toString().split('?')[0];
  var _iterator = _createForOfIteratorHelper(keys),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;
      params.delete(key);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var resultParams = params.toString() ? "?".concat(params.toString()) : '';
  window.top.history.replaceState('data', 'title', "".concat(urlNoParams).concat(resultParams));
};
// FIXME obsolete
var getParameterFromUrlWithoutDecoding = function getParameterFromUrlWithoutDecoding(key) {
  if (!window.top) {
    return;
  }
  var url = new URL(window.top.location.href);
  return url.searchParams.get(key);
};
var addHashToUrl = function addHashToUrl(hash) {
  if (!window.top) {
    return;
  }
  var href = window.top.location.href;
  if (href.includes('#')) {
    href = href.substring(0, href.indexOf('#'));
  }
  window.top.history.replaceState('data', 'title', "".concat(href, "#").concat(hash));
};
var removeHashFromUrl = function removeHashFromUrl() {
  if (!window.top) {
    return;
  }
  var href = window.top.location.href;
  if (href.includes('#')) {
    var updatedHref = href.substring(0, href.indexOf('#'));
    window.top.history.replaceState('data', 'title', updatedHref);
  }
};
var getHashFromUrl = function getHashFromUrl() {
  if (!window.top) {
    return null;
  }
  var hash = window.top.location.hash;
  return hash ? hash.slice(1) : undefined;
};

export { addHashToUrl, addParameterToUrl, getHashFromUrl, getParameterFromUrl, getParameterFromUrlWithoutDecoding, removeHashFromUrl, removeParamsFromUrl };
